import { ApolloWrapper } from '@/lib/apollo-provider';
import { AuthProvider } from '@/lib/auth-provider';
import TrainScreenLight from '@/ui/pages/TrainScreenLight';
import { useOrientationLock } from '@/hooks/useOrientationLock';
import { isEmbedded } from '@/lib/utils';

function App() {
  const embedded = isEmbedded();
  useOrientationLock(!embedded);

  return (
    <ApolloWrapper>
      <AuthProvider>
        <TrainScreenLight embedded={embedded} />
      </AuthProvider>
    </ApolloWrapper>
  );
}

export default App;
